export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/e3f8e2b51a2bd5161ac4b91e40aac291.jpg"
          alt="Robotic automation"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center w-full">
        <div className="inline-block mb-6 px-4 py-2 border-2 border-orange-500 rounded-full bg-black/30 backdrop-blur-sm">
          <span className="text-orange-400 text-sm font-semibold tracking-wide">INNOVACIÓN EN AUTOMATIZACIÓN</span>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-black text-white mb-6 leading-tight">
          SOLUCIONES ROBÓTICAS
          <br />
          <span className="bg-gradient-to-r from-orange-500 to-green-500 bg-clip-text text-transparent">
            INTELIGENTES
          </span>{' '}
          PARA TU INDUSTRIA
        </h1>

        <p className="text-lg sm:text-xl md:text-2xl text-gray-200 mb-12 max-w-3xl mx-auto">
          Desde la idea hasta la máquina perfecta. Tecnología de vanguardia con IA integrada
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => scrollToSection('projects')}
            className="px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-base font-semibold rounded-full hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
          >
            Ver Proyectos →
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className="px-8 py-4 border-2 border-white text-white text-base font-semibold rounded-full hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer"
          >
            Conocer Servicios
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
